"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sectorSlider = void 0;
const sectorSlider = () => {
    /**
     * Header and navigation hooks
     */
    const sectorSlider = document.querySelector('.sector-slider__track');
    const slides = document.querySelector('[data-reveal="slides"]');
    if (!slides) {
        return;
    }
    slides.addEventListener('mouseenter', () => {
        sectorSlider.classList.add('is-active');
    });
    slides.addEventListener('mouseleave', () => {
        sectorSlider.classList.remove('is-active');
    });
};
exports.sectorSlider = sectorSlider;
